var map = {
	"./Acumulado_de_Chuva.png": 92,
	"./Baixa_Umidade.png": 89,
	"./Chuvas_Intensas.png": 81,
	"./Declinio_de_Temperatura.png": 91,
	"./Estiagem.png": 86,
	"./Friagem.png": 84,
	"./Geada.png": 85,
	"./Granizo.png": 80,
	"./Incendios.png": 88,
	"./Neve.png": 90,
	"./Onda_de_Calor.png": 83,
	"./Onda_de_Frio.png": 77,
	"./Onde_de_Calor.png": 208,
	"./Onde_de_Frio.png": 209,
	"./Ressaca.png": 76,
	"./Seca.png": 87,
	"./Tempestade.png": 93,
	"./Tempestade_de_Raios.png": 79,
	"./Tornados.png": 78,
	"./Vendaval.png": 82,
	"./Ventos_Costeiros.png": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;